import Typography from "../../../../designComponents/Typography";

type Props = {
  description: string;
};

const PropertyDescriptionViewer = ({ description }: Props) => {
  if (description?.length === 0 || !description) {
    return null;
  }
  return (
    <div>
      <Typography>{description}</Typography>
    </div>
  );
};

export default PropertyDescriptionViewer;
